// TODO: cannot import typings and somehow ts does not know where to look for
//import 'googlemaps';

export class FitBoundsPadding {
	top? = 0;
	left? = 0;
	bottom? = 0;
	right? = 0;
}

export function fitBoundsWithPadding(
	map: google.maps.Map,
	bounds: google.maps.LatLngBounds,
	padding: FitBoundsPadding
) {
	const projection = map.getProjection();
	if (projection) {
		// copying the bounds object, since we will extend it
		bounds = new google.maps.LatLngBounds(
			bounds.getSouthWest(),
			bounds.getNorthEast()
		);

		// SW
		let point1 = projection.fromLatLngToPoint(bounds.getSouthWest());
		map.fitBounds(bounds);

		let point2 = new google.maps.Point(
			(typeof padding.left === 'number' ? padding.left : 0) /
				Math.pow(2, map.getZoom()) || 0,
			(typeof padding.bottom === 'number' ? padding.bottom : 0) /
				Math.pow(2, map.getZoom()) || 0
		);

		let newPoint = projection.fromPointToLatLng(
			new google.maps.Point(point1.x - point2.x, point1.y + point2.y)
		);

		bounds.extend(newPoint);

		point1 = projection.fromLatLngToPoint(bounds.getNorthEast());
		point2 = new google.maps.Point(
			(typeof padding.right === 'number' ? padding.right : 0) /
				Math.pow(2, map.getZoom()) || 0,
			(typeof padding.top === 'number' ? padding.top : 0) /
				Math.pow(2, map.getZoom()) || 0
		);
		newPoint = projection.fromPointToLatLng(
			new google.maps.Point(point1.x + point2.x, point1.y - point2.y)
		);

		bounds.extend(newPoint);
		map.fitBounds(bounds);
	}
}
